import { render, staticRenderFns } from "./LogbookOld.vue?vue&type=template&id=2881e763"
import script from "./LogbookOld.vue?vue&type=script&lang=js"
export * from "./LogbookOld.vue?vue&type=script&lang=js"
import style0 from "./LogbookOld.vue?vue&type=style&index=0&id=2881e763&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports